import { ReactNode } from 'react';
import { FeatureModalImage } from './features-image-modal';
import clsx from 'clsx';
import { FeaturePreviewImage } from './features-preview-image';

type FeatureSectionProps = {
  actions?: ReactNode;
  children: ReactNode;
  id?: string;
  image?: FeatureModalImage;
  images?: FeatureModalImage[];
  imageClassName?: string;
  imageFramed?: boolean;
  imagePosition?: 'left' | 'right';
  onOpenImage: (image: FeatureModalImage) => void;
  title: ReactNode;
};

export function FeatureSection({
  actions,
  children,
  id,
  image,
  images,
  imageClassName,
  imageFramed = true,
  imagePosition = 'left',
  onOpenImage,
  title,
}: FeatureSectionProps) {
  const isImageRight = imagePosition === 'right';
  const hasMultipleImages = Boolean(images?.length);
  const hasSingleImage = Boolean(image);
  let imagePreview: ReactNode = null;

  if (hasMultipleImages && images) {
    imagePreview = (
      <FeaturePreviewImage
        imageClassName={imageClassName}
        imageFramed={imageFramed}
        images={images}
        onOpenImage={onOpenImage}
      />
    );
  } else if (hasSingleImage && image) {
    imagePreview = (
      <FeaturePreviewImage
        image={image}
        imageClassName={imageClassName}
        imageFramed={imageFramed}
        onOpenImage={onOpenImage}
      />
    );
  }

  return (
    <section
      id={id}
      className={clsx(
        'grid grid-cols-1 items-center justify-items-start gap-4 lg:grid-cols-2 lg:gap-8',
        id && 'scroll-mt-32',
      )}
    >
      <div className={clsx(isImageRight ? 'lg:order-2' : 'lg:order-1', 'h-full')}>
        {imagePreview}
      </div>

      <div className={clsx('flex flex-col gap-4', isImageRight ? 'lg:order-1' : 'lg:order-2')}>
        <h3>{title}</h3>
        {children}
        {actions}
      </div>
    </section>
  );
}
